import { Avatar, Badge, IconButton, Theme, Tooltip, useMediaQuery } from '@mui/material';
import { useCallback, useRef, useState } from 'react';
import { accountMenuStyles } from './styles';
import { userApi } from '../../../store/features/user/userSlice';
import { removeTokenFromStorage } from '../../../utils/token';
import { useAppDispatch } from '../../../store/hooks';
import { DesktopProfileMenu } from './DesktopProfileMenu';
import { TabletProfileMenu } from './TabletProfileMenu';
import { Link } from 'react-router-dom';
import { APP_URLS } from '../../../routes/urls';
import { ChatIcon } from '../../../assets/icons';
import { AppIcon } from '../../app-icon/AppIcon';
import { useUnreadCountQuery } from '../../../store/features/inquiry/inquirySlice';

interface ProfileMenuProps {
  slug: string;
  userId: string;
  fullName: string;
  profilePicture: string;
}
export const ProfileMenu: React.FC<ProfileMenuProps> = ({ slug, userId, fullName, profilePicture }) => {
  const { currentData } = useUnreadCountQuery(undefined, { pollingInterval: 60000 }); // 60000 = 60 * 1000 ms = 1 minute

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuAnchorEl = useRef<HTMLButtonElement | null>(null);
  const toggleIsMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  /**
   * Functionality to log out user
   */
  const dispatch = useAppDispatch();
  const signOutUser = () => {
    dispatch(
      userApi.util.updateQueryData('getProfile', { slug, userId }, () => ({
        token: null,
        user: undefined,
      }))
    );
    removeTokenFromStorage();
  };

  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  return (
    <>
      <Tooltip title="Inbox">
        <IconButton sx={{ mr: 2, color: 'common.black' }} component={Link} to={APP_URLS.inboxList}>
          <Badge color="error" badgeContent={currentData?.count} invisible={!currentData || currentData.count < 1}>
            <AppIcon Icon={ChatIcon} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Tooltip title="Open Account Menu">
        <IconButton ref={menuAnchorEl} onClick={toggleIsMenuOpen} sx={accountMenuStyles.avatarBtn}>
          <Avatar alt={fullName} src={profilePicture} />
        </IconButton>
      </Tooltip>
      {isTablet ? (
        <TabletProfileMenu signOut={signOutUser} isDrawerOpen={isMenuOpen} onCloseDrawer={closeMenu} />
      ) : (
        <DesktopProfileMenu
          isMenuOpen={isMenuOpen}
          toggleIsMenuOpen={toggleIsMenuOpen}
          slug={slug}
          menuAnchorEl={menuAnchorEl.current}
          signOut={signOutUser}
        />
      )}
    </>
  );
};
